export function mapDataToShapes(shapesData) {    
    let fn = mapMarketToShape;
    return shapesData.map(fn);
}

function mapMarketToShape(market) {    
    return {
        id: market.Geo,
        
        GeoName: market.GeoName,        
        Population: market.Population,        
        PopulationGrowth1Yr: market.PopulationGrowth1Yr,
        PopulationGrowth5Yr: market.PopulationGrowth5Yr,
        MedianIncome: market.MedianIncome,
        MedianIncomeGrowth1Yr: market.MedianIncomeGrowth1Yr,
        MedianIncomeGrowth5Yr: market.MedianIncomeGrowth5Yr,
        UnemploymentRate: market.UnemploymentRate,
        UnemploymentRateChg1Yr: market.UnemploymentRateChg1Yr,
        UnemploymentRateChg5Yr: market.UnemploymentRateChg5Yr,
        EmploymentGrowth1Yr: market.EmploymentGrowth1Yr,
        EmploymentGrowth5Yr: market.EmploymentGrowth5Yr,
        HousingUnitsSFDetached: market.HousingUnitsSFDetached,
        OwnerOccupiedPctSFDetached: market.OwnerOccupiedPctSFDetached,
        RenterOccupiedPctSFDetached: market.RenterOccupiedPctSFDetached,
        MedianHomeValue: market.MedianHomeValue,
        MedianRent: market.MedianRent,
        NetMigration1Yr: market.NetMigration1Yr,
        NetMigration5Yr: market.NetMigration5Yr,
        HPA1Yr: market.HPA1Yr,

        polygons: market.Polygons
    }
}
